import { createContext, useContext, useEffect, useState, useMemo } from "react";
import { T } from "@/lib/i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("tn2026_lang") || "en");

  useEffect(() => {
    localStorage.setItem("tn2026_lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: (key) => {
        const bucket = T[lang] || T.en;
        return bucket[key] ?? T.en[key] ?? key;
      },
      toggle: () => setLang((l) => (l === "en" ? "ta" : "en")),
    }),
    [lang]
  );

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LangProvider");
  return ctx;
}
